import { noop } from 'lodash/fp';
import PropTypes from 'prop-types';
import elementType from 'prop-types-extra/lib/elementType';

export const FIELD_INDEX = 0;

export const vehiclePropTypes = {
  clearable: PropTypes.bool,
  component: elementType,
  fieldIndex: PropTypes.number,
  onChanged: PropTypes.func,
  options: PropTypes.array,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  searchable: PropTypes.bool,
};

export const vehicleDefaultProps = {
  clearable: true,
  fieldIndex: FIELD_INDEX,
  onChanged: noop,
  placeholder: __('search.filters.any'),
  searchable: true,
};
